import HandleLettersOld from './HandleLettersOld.jsx';
export {
  HandleLettersOld
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/list-handle-letters-old/index.js